import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../../shared";
import { PersonSelectorService } from "../../../../personselector/personselector.service";
import { ReportService } from "../../../../Report/report.service";
import { DataService_StudentFinesDebts } from "../../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-manual-fine-table",
	templateUrl: "./manual-fine-table.component.html",
	styleUrls: ["./manual-fine-table.component.css"],
})
export class ManualFineTableComponent implements OnInit {
	constructor(private StudentFinesDebtsService: DataService_StudentFinesDebts) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadFine();
	}

	ngOnChanges() {
		this.loadFine();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedPerson: any;

	@Output() ManualDataChange: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedFine: any;
	lstFine: any = [];

	//Filter lists
	lstFineTypeDesc: any = [];
	lstPartOfGroupAction: any = [];

	//Cols
	cols1: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FineDateDesc", header: "Date/Time" },
		{ field: "FineTypeDesc", header: "Fine Type" },
		{ field: "AmountDesc", header: "Charged" },
	];

	cols2: any = [
		// { field: 'WaivedDesc', header: 'Adjusted' },
		// { field: 'PaidDesc', header: 'Paid' },
		{ field: "BalanceDesc", header: "Balance" },
		{ field: "FineComment", header: "Comments" },
		{ field: "PartOfGroupAction", header: "Part of Group Action" },
		{ field: "GroupName", header: "GroupName" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadFine() {
		this.loading = true;

		if (this.SelectedPerson == undefined) {
			this.lstFine = [];
			this.lstFineTypeDesc = [];

			this.loading = false;

			return;
		}

		var result = this.StudentFinesDebtsService.LoadFine(this.SelectedPerson.PersonID, 1, 1, this.SelectedPerson.SchoolID);
		result.subscribe(
			(response) => {
				this.lstFine = response;

				for (var i = 0; i < this.lstFine.length; i++) {
					var next = this.lstFine[i];

					// Reset paid and waived
					// Add paid and waived to current paid and waived
					next.Paid = 0;
					next.PaidDesc = "$0.00";
					next.Waived = 0;
					next.WaivedDesc = "$0.00";

					next.FineDateDesc = moment(new Date(next.FineDate)).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstFineTypeDesc = Array.from(new Set(this.lstFine.map((item: any) => item.FineTypeDesc))).sort();
				this.lstPartOfGroupAction = Array.from(new Set(this.lstFine.map((item: any) => item.PartOfGroupAction))).sort();

				this.ManualDataChange.emit(1);

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onWaivedChange(val, Fine) {
		// console.log("Val");
		// console.log(val);

		// console.log("Fine");
		// console.log(Fine);

		Fine.Waived = val;

		Fine.Balance = Fine.StartAmount - Fine.Paid - Fine.Waived;

		Fine.BalanceDesc = "$" + Number(Fine.Balance).toFixed(2);

		this.ManualDataChange.emit(1);
	}

	onPaidChange(val, Fine) {
		// console.log("Val");
		// console.log(val);

		// console.log("Fine");
		// console.log(Fine);

		Fine.Paid = val;

		Fine.Balance = Fine.StartAmount - Fine.Paid - Fine.Waived;

		Fine.BalanceDesc = "$" + Number(Fine.Balance).toFixed(2);

		this.ManualDataChange.emit(1);
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	////////////////////////////////////////////
}
